import { useScraperTranslations } from '@/blocks/Scraper/scraperTranslations';
import { FormFieldProps } from '@/blocks/Scraper/types';
import { InputDropdown } from '@/components/atoms/InputDropdown';
import { useTranslation } from '@/lib/i18n/i18n.client';

const FormSelectField = (props: FormFieldProps) => {
  const { param, form } = props;

  const field = form.getFieldProps(param.key);
  const { texts } = useTranslation();
  const { getTranslation } = useScraperTranslations();
  const options =
    param.options?.map((option) => {
      if (typeof option === 'string') {
        return {
          label: option,
          value: option.toString(),
        };
      }
      return {
        label: option.label,
        value: option.value.toString(),
      };
    }) ?? [];

  return (
    <InputDropdown
      {...field}
      value={(field.value as string) || ''}
      label={getTranslation(param.header.id ?? '')}
      hideBottomText
      placeholder={texts.input_dropdown.dropdown_placeholder}
      options={options}
      tooltip={getTranslation(param.description?.id ?? '')}
      onOptionChange={(value) => form.setFieldValue(field.name, value)}
      classNames={{
        tooltip: {
          targetContainer: 'ml-2',
        },
        search: {
          input: {
            inputElement: 'bg-base-white dark:bg-gray-50',
          },
        },
        root: 'w-full text-left mb-0',

        inputField: {
          root: 'bg-base-white dark:bg-gray-50 text-body-m',
        },
      }}
      targetClassNames={{
        label: {
          root: 'text-body-l',
        },
      }}
      hasSearch
    />
  );
};

export default FormSelectField;
